import React from 'react';
import styles from './HelpCentrePage.css';
import StringWidget from 'components/StringWidget/StringWidget';
import cx from 'classnames';
export default function HelpCentrePlaceholder() {
    return (<div className={cx(styles['title'], styles['new-header-exp'])}>
			<StringWidget strKey="helpCenterTitle"/>
		</div>);
}
